import type { Option } from '@pbk-web/types';
import { type ImageSize, ProfileImageStack, Tooltip } from '@pbk-web/ui';
import { StringUtils } from '@pbk-web/utils';
import type { FC } from 'react';

import { PeopleType } from '../../models/Distribution';

const UserListRenderer: FC<
  Option<string, number> & { size?: ImageSize; textHighlight?: string; userImageId?: string; suffix?: string; suffixPosition?: 'inline' | 'below' }
> = (props) => {
  const { id, text, value, size, textHighlight, userImageId, suffix, suffixPosition = 'inline' } = props;
  const [fn, ...lns] = text.split(' ');
  const ln = lns.join(' ');

  return (
    <div className="flex max-w-full min-w-0 items-center py-1 pr-1">
      <ProfileImageStack users={[{ firstName: fn, lastName: ln, id: value === PeopleType.Member ? (id ?? '') : '', userImageId }]} size={size} />
      <Tooltip text={StringUtils.highlightText(text, textHighlight)} truncatedTextMode>
        {(tooltip) => (
          <div {...tooltip} className={`ml-2 truncate leading-none ${suffixPosition === 'below' ? 'flex flex-col' : 'flex items-center'}`}>
            <span className="truncate">{StringUtils.highlightText(text, textHighlight)}</span>
            {suffix && (
              <span className={`text-pbk-14 text-text-2 font-light ${suffixPosition === 'below' ? 'mt-1' : 'ml-2'} truncate leading-none`}>
                {suffix}
              </span>
            )}
          </div>
        )}
      </Tooltip>
    </div>
  );
};

export default UserListRenderer;
